import React, { useState, useEffect } from 'react';
import { Layout, Tooltip } from 'antd';
import { getHeaderBroadcast, HeaderBroadcast } from 'controller/auth';
import { Outlet } from 'react-router-dom';
import { useResponsive } from 'antd-style';
import Header from './Header';
import SiderMenu from './SiderMenu';
import SiderDrawer from './siderDrawer';
import { useStyles } from './index.style';
import classNames from 'classnames';

const { Content } = Layout;

const App: React.FC = () => {
  const { desktop, mobile, tablet, laptop } = useResponsive();
  const [openSidebar, setOpenSidebar] = useState(false);
  const { styles } = useStyles();
  const [list, setList] = useState<HeaderBroadcast[]>([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const getList = async () => {
      const res = await getHeaderBroadcast({
        size: 10,
        current: 1
      });
      if (res.success) {
        setList(res.data?.data || []);
      }
    };
    getList();
  }, []);

  useEffect(() => {
    if (list.length === 0 || list.length - 1) return;
    const timer = setInterval(() => {
      setCurrent((_current) => (_current >= list.length - 1 ? 0 : _current + 1));
    }, 3000);
    return () => {
      clearInterval(timer);
    };
  }, [list]);

  return (
    <>
      {list.length !== 0 && (
        <Tooltip title={list[current] && list[current].msg}>
          <div className={styles.topHeader}>{list[current] && list[current].msg}</div>
        </Tooltip>
      )}
      <Layout className={classNames(styles.container, list.length !== 0 && styles.container2)}>
        {!laptop ? <SiderDrawer open={openSidebar} onClose={() => setOpenSidebar(false)} /> : <SiderMenu />}

        <Layout className={styles.contentWrap}>
          <Header onOpen={() => setOpenSidebar(true)} />
          <Content className={styles.content}>
            <div className={styles.contentInfo} style={{ maxWidth: desktop ? '1500px' : '1286px' }}>
              <div className={styles.outlet}>
                <Outlet />
              </div>
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default App;
